
const SET_LOGIN_INFORMATION = (state, settings) => {
  state.loginInformation = settings;
};

const SET_PURCHASE_TYPE = (state, type) => {
  state.purchaseType = type;
};

const UNSET_PURCHASE_TYPE = (state) => {
  state.purchaseType = undefined;
};

export default {
  SET_LOGIN_INFORMATION,
  SET_PURCHASE_TYPE,
  UNSET_PURCHASE_TYPE,
};
